export const CTADestinationOptions = [
  { value: "game", label: "Game" },
  { value: "url", label: "URL" },
];
